import { render } from "./DataForm.vue?vue&type=template&id=06f59e25&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"

import "./DataForm.vue?vue&type=style&index=0&id=06f59e25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f59e25"]])

export default __exports__